<template>
  <div class="store-picker-layer" role="dialog" aria-modal="true" aria-label="상담받을 매장 선택">
    <div class="store-picker-bar">
      <button type="button" class="store-picker-back" aria-label="신청서로 돌아가기" @click="$emit('close')">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15 5l-7 7 7 7" />
        </svg>
      </button>
      <h2>상담받을 매장 선택</h2>
    </div>
    <store-finder
        mode="picker"
        :initial-store-code="initialStoreCode"
        @select="$emit('select', $event)"
    />
  </div>
</template>

<script>
import StoreFinder from "@/components/SUPPORT/StoreFinder.vue";

// 신청서 위에 전체 화면으로 매장찾기를 띄우고, 고르면 신청서로 돌아간다
export default {
  name: "StorePickerLayer",
  components: { StoreFinder },
  props: {
    initialStoreCode: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";

.store-picker-layer {
  // 매장찾기 화면이 위 막대(56px) 바로 아래부터 그려지도록, 이 안에서만 헤더 높이 값을 바꾼다
  --header-height: 56px;
  position: fixed;
  top: 0;
  // 스크롤을 잠그면 막대가 사라지므로, 그 폭만큼 비워 본문과 같은 자리에 선다
  right: var(--scroll-lock-pad, 0px);
  bottom: 0;
  left: 0;
  // 사이트 본문 폭(500px) 안에서 가운데
  max-width: 500px;
  margin: 0 auto;
  z-index: 1300; // 헤더(1000~1200)·위로가기 버튼 위
  overflow: hidden;
  background-color: $color-white;
}
.store-picker-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  border-bottom: 1px solid #dedede;
  background-color: $color-white;
  h2 {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.3px;
    color: #222;
  }
}
.store-picker-back {
  position: absolute;
  top: 6px;
  left: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 0;
  width: 44px;
  height: 44px;
  svg {
    width: 24px;
    height: 24px;
    fill: none;
    stroke: #222;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}
</style>
